const colors = {
  'primary-50': '#E8EBFA',
  'primary-100': '#B6C0EF',
  'primary-200': '#93A2E7',
  'primary-300': '#6277DC',
  'primary-400': '#435DD5',
  'primary-500': '#120A8F',
  'primary-600': '#122FB9',
  'primary-700': '#0E2590',
  'primary-800': '#0B1D70',
  'primary-900': '#081655',

  'secondary-50': '#FFF9E8',
  'secondary-100': '#FEEBB6',
  'secondary-200': '#FEE293',
  'secondary-300': '#FDD562',
  'secondary-400': '#FDCD44',
  'secondary-500': '#FCC015',
  'secondary-600': '#E5AF13',
  'secondary-700': '#B3880F',
  'secondary-800': '#8B6A0C',
  'secondary-900': '#6A5109',

  'info-50': '#E8F1FF',
  'info-100': '#B7D5FE',
  'info-200': '#94C0FE',
  'info-300': '#63A3FD',
  'info-400': '#4591FD',
  'info-500': '#1676FC',
  'info-600': '#146BE5',
  'info-700': '#1054B3',
  'info-800': '#0C418B',
  'info-900': '#09326A',

  'success-50': '#EEF9E8',
  'success-100': '#C9EDB8',
  'success-200': '#AFE496',
  'success-300': '#8BD766',
  'success-400': '#75D048',
  'success-500': '#52C41A',
  'success-600': '#4BB218',
  'success-700': '#3A8B12',
  'success-800': '#2D6C0E',
  'success-900': '#22520B',

  'danger-50': '#FDEDED',
  'danger-100': '#F8C6C6',
  'danger-200': '#F5AAAB',
  'danger-300': '#F18484',
  'danger-400': '#EE6C6D',
  'danger-500': '#EA4748',
  'danger-600': '#D54142',
  'danger-700': '#A63233',
  'danger-800': '#812728',
  'danger-900': '#621E1E',

  'neutral-10': '#FFFFFF',
  'neutral-20': '#FAFAFA',
  'neutral-30': '#F4F4F4',
  'neutral-40': '#EDEDED',
  'neutral-50': '#E1E1E1',
  'neutral-60': '#D2D2D2',
  'neutral-70': '#C3C3C3',
  'neutral-80': '#B5B5B5',
  'neutral-90': '#A6A6A6',
  'neutral-100': '#959595',
  'neutral-200': '#888888',
  'neutral-300': '#6B6B6B',
  'neutral-400': '#4D4D4D',
  'neutral-500': '#3E3E3E',
  'neutral-600': '#2E2E2E',
  'neutral-700': '#1F1F1F',
  'neutral-800': '#171717',
  'neutral-900': '#0F0F0F',

  primary: '#120A8F',
  secondary: '#F5BF13',
  placeholder: '#808080',
  heading: '#5A4FCF',
  subheading: '#E6E6E6',
  white: '#FFFFFF',
  black: '#000000',
  mutedPrimary: '#021E4C',
  mutedSecondary: '#BD9D64',
  mutedWhite: '#EBEBEB',
  mutedBlack: '#908C89',
  titleColor: '#3E3E3E',
  menuTitleColor: '#333333',
  formColor: '#f5f5f5',
  selectBorder: '#D9D9D9',
  searchIcon: '#808080',
  siderMenuColor: '#3d5ccb',
  tableHeadBg: '#F4F4F4',
  tableHoverBg: '#F4F4F4',
  tableBorder: '#EDEDED',
  tableHeaderColor: '#6B6B6B',
};

export default colors;
